export const SET_USER_NAME = 'SET_USER_NAME'
export const SET_USER_ID = 'SET_USER_ID'
export const SET_USER_IMG = 'SET_USER_IMG'
export const SET_USER_ID_COMPANY = 'SET_USER_ID_COMPANY'


/* project types */

export const SET_CUR_PATH = 'SET_CUR_PATH'